module.exports = __webpack_public_path__ + "static/media/screen6.3b415ff3.png";